import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { IOpenMarketProduct } from '../../../../interfaces/OpenMarketProduct.interfaces';
import { getNextOpenMarketProducts } from '../../../../api/product/queries/getNextOpenMarketProducts';

interface IUseGetNextSellProductsQueryParams {
  searchParam: {
    id: string;
  };
  options?: UseQueryOptions<IOpenMarketProduct[], AxiosError>;
}

export const useGetNextOpenMarketProductsQuery = ({ searchParam, options }: IUseGetNextSellProductsQueryParams) => {
  return useQuery<IOpenMarketProduct[], AxiosError>(
    ['user-sell-tractors-next', `id=${searchParam.id}`],
    () => getNextOpenMarketProducts({ productId: searchParam?.id }),
    options,
  );
};
